import React, { FC } from 'react';

import { Stack, Text } from '@chakra-ui/react';

import { KnowledgeBaseDrawer } from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseDrawer';
import {
  KnowledgeBaseLink,
  KnowledgeBaseLinks,
} from 'components/DataDisplay/KnowledgeBase/BaseComponents/KnowledgeBaseLinks';

export const LearnMoreAboutExceptions: FC = () => {
  const links: KnowledgeBaseLink[] = [
    { label: 'Policies', field: 'policies' },
    { label: 'Policy Blueprints', field: 'blueprints' },
    { label: 'Ticketing', field: 'ticketing' },
  ];

  return (
    <KnowledgeBaseDrawer
      knowledgeBaseKey="exceptions"
      headerTitle="Exceptions"
      body={
        <Stack spacing={8}>
          <Stack spacing={4}>
            <Text fontWeight={600}>Overview</Text>
            <Text>
              Ariksa provides comprehensive lifecycle management of policies
              that are enforced in your cloud. One important aspect is managing
              exceptions to policy enforcement either for all resources or on a
              per-resource basis.
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Text fontWeight={600}>Policy Exceptions</Text>
            <Text>
              Policy exceptions are applied when specific policy violations are
              deemed necessary for business enablement and post acceptable
              levels of risks to your cloud. When a policy exception is applied,
              all violations associated with policy (across every individual
              resource) is ignored and no issue is raised. Policy exceptions can
              be time-bound – applied for a specific period or forever. Time-
              bound policies are automatically evaluated for violation upon
              expiration. You can review resource exceptions by clicking on
              EXCEPTIONS for any blueprint.
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Text fontWeight={600}>Resource Exceptions</Text>
            <Text>
              Resource exceptions provide more granular control for managing and
              accepting risks in your cloud. Resource exceptions allow policy
              violations associated with specific resources to be ignored, so
              that no issues are raised. Like policy exceptions, resource
              exceptions are also time- bound and follow the same rules for
              re-evaluation when the exception is time-bound. You can review
              resource exceptions by clicking on EXCEPTIONS for any blueprint.
            </Text>
          </Stack>
          <KnowledgeBaseLinks links={links} />
        </Stack>
      }
    />
  );
};
